// Owner: mail (wave 2, plan §9.7). Command bar items of the mail area (⌘K): "New e-mail", "E-mail
// drafts" and "Mail templates". Discovered by glob (`features/**/commands.ts`) and loaded with the shell,
// so this file stays tiny: the items and their messages load on the first search.
import { defineAppCommands } from '../../extensions/commands';

export default defineAppCommands({
  id: 'mail',
  providers: [
    {
      id: 'mail.compose',
      items: async (query) => {
        if (!query.trim()) return [];
        const { mailCommandItems } = await import('./command-items');
        return mailCommandItems(query);
      },
    },
  ],
});
